// 产品展示+搜索结果
export default {
  //分类列表
  TypeList: 'TypeList',
  // 产品列表
  ProductList:'ProductList',
};